import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Site-wide subtle banner shown when the current drop is running low
 * (0 < remaining < THRESHOLD). Hidden when fully sold out (handled elsewhere)
 * and hidden when plenty of stock remains. Sits above the Header.
 */
const THRESHOLD = 15;

const LowStockBanner = () => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/inventory")
      .then((r) => {
        if (cancelled) return;
        const rem = r?.data?.remaining;
        if (typeof rem === "number") setRemaining(rem);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (remaining === null || remaining <= 0 || remaining >= THRESHOLD) {
    return null;
  }

  return (
    <div
      data-testid="low-stock-banner"
      className="w-full bg-[#FFF1F5] border-b border-black/15"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-2 flex items-center justify-center gap-2">
        <span
          aria-hidden
          className="inline-block w-1.5 h-1.5 rounded-full bg-[#FF1493]"
        />
        <span className="overline text-[10px] tracking-[0.28em] text-black/80">
          Only{" "}
          <span
            data-testid="low-stock-remaining"
            className="font-serif-display not-italic tracking-normal text-[13px] font-black text-[#FF1493]"
          >
            {remaining}
          </span>{" "}
          bottle{remaining === 1 ? "" : "s"} left in this drop
        </span>
      </div>
    </div>
  );
};

export default LowStockBanner;
